import React, { useEffect, useMemo, useState } from "react";
import { MaterialReactTable, useMaterialReactTable, MRT_ExpandAllButton } from "material-react-table";
import { AddIcon, Backdrop, Box, Button, Chip, CloseIcon, DeleteIcon, Dialog, DialogActions, DialogContent, DialogTitle, EditIcon, Fab, Grid, IconButton, Slide, Stack, Tooltip } from "../../styles/MaterialUI";
import "../.././styles/CustomStyle.css";
import apiConstants from "../../constants/apiConstants";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import MegaMenu from "../megamenu/MegaMenu";
import PreviewContent from "../PreviewContent/PreviewContent";
import ContentProgress from "../contentprogress/ContentProgress";
import { useDispatch, useSelector } from "react-redux";
import { ThreeDots } from "react-loader-spinner";
import MappedContentList from "../MappedContentList/MappedContentList";
import CreateContentDialog from "../ContentComponents/CreateContentDialog";
import { getMenuDataList, resetDashboardState } from "../Redux/Features/addContentSlice";
import EditContentDialog from "../ContentComponents/EditContentDialog";
import { getScreenData, setEditContentRowData } from "../Redux/Features/editContentSlice";
import MapContentDialog from "../ContentComponents/MapContentDialog";
import { getSelectedContent } from "../Redux/Features/mapContentSlice";
import { resetContentUploadProgress } from "../Redux/Features/reloadMetricsSlice";
import { showAlertPopup } from "../Redux/Features/showAlertSlice";
import { setContentGlobalSearch } from "../Redux/Features/searchParamsSlice";
import { useOrgConfigData } from "../../hooks/useOrgConfigData";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ContentTable = () => {
  const { isInternalUserMapped } = useSelector((state) => state.userLogin);
  const { userToken } = useSelector((state) => state.userToken);
  const orgConfig = useOrgConfigData("contentTable");
  const {
    org_properties: org_configurations
  } = orgConfig || {};
  const { uploadPercent, uploadFilename } = useSelector((state) => state.reloadMetrics);
  const { contentGlobalSearchData } = useSelector((state) => state.searchParams);
  const [isLoading, setIsLoading] = useState(false);
  const headers = { Authorization: `Bearer ${userToken}` };
  const [tableValues, setTableValues] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [rowData, setRowData] = useState({});
  const [openDrawer, setOpenDrawer] = useState(false);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight * 0.5);
  const dispatch = useDispatch();

  const [addContentDialog, setAddContentDialog] = useState(false);
  const [editContentModal, setEditContentModal] = useState(false);

  const [contentWarning, setContentWarning] = useState({ type: null, contentIds: null, contentStatus: null, contentData: null, modifiedStatus: null });
  const [previewModal, setPreviewModal] = useState({ openPreview: false, contentType: "", chooseFit: "", previewData: "" });
  const [openProgress, setOpenProgress] = useState(false);
  const [contentType, setContentType] = useState("");
  const [uploadFileLoader, setUploadFileLoader] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);
  const contentTypeMap = { "image": "Image", "video": "Video", "dashboard": "IntelliDash Dashboard", "content_playlist": "Content Playlist", "open_url": "Open URL" };
  const contentWarningTypes = ["ContentInScreenOrPlaylist_EnableState", "ContentInScreenOrPlaylist_DisableState", "ContentNotInScreenOrPlaylist_EnableState", "ContentNotInScreenOrPlaylist_DisableState",
    "ContentInScreenOrPlaylist_SingleDelete", "ContentNotInScreenOrPlaylist_SingleDelete", "ContentInScreenOrPlaylist_MultiDelete", "ContentNotInScreenOrPlaylist_MultiDelete"
  ];
  const contentTypesToShow = ["ContentInScreenOrPlaylist_EnableState", "ContentInScreenOrPlaylist_DisableState", "ContentInScreenOrPlaylist_SingleDelete", "ContentInScreenOrPlaylist_MultiDelete"];
  const [isContentStatusChanged, setIsContentStatusChanged] = useState(false);
  const [contentFilename, setContentFilename] = useState("");
  const [contentUploadProgressText, setContentUploadProgressText] = useState("");
  const [integrationActiveFlag, setIntegrationActiveFlag] = useState(0);
  const [globalFilter, setGlobalFilter] = useState("");
  const [initialLoad, setInitialLoad] = useState(false);
  // ── Limits derived from org_properties ──────────────────────────────────
  const aristocastLimits = org_configurations?.aristocast_limits ?? {};
  const maxContents = aristocastLimits.max_limit_of_aristocast_contents ?? 0;

  const getIntegrationData = async () => {
    const apiResponse = await axios.post(`${apiConstants.GET_API_URL}getIntegrations`, {}, { headers });
    const { data } = apiResponse.data;
    const activeFlag = data?.[0]?.ic_activeflag;
    setIntegrationActiveFlag(activeFlag);
    return data;
  }

  const getMetricsDashboardTypes = async () => {
    const apiResponse = await axios.post(`${apiConstants.GET_API_URL}getDashboardTypes`, {}, { headers });
    const { data } = apiResponse.data;
    return data;
  }

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const integrationData = await getIntegrationData();
      const DashboardTypes = await getMetricsDashboardTypes();
      const response = await axios.post(`${apiConstants.GET_API_URL}getContents`, { org_id: "test" }, { headers });
      const { data } = response.data;

      data.forEach(item => {
        item.ic_content_status = item.ic_content_status === 1 ? "Enabled" : "Disabled";
        item.ic_createdon = formatDate(item.ic_createdon);
        item.ic_updatedon = formatDate(item.ic_updatedon);

        item.ic_dashboard_view = item.ic_org_integration_id
          ? item.ic_dashboard_url
          : item.ic_mm_dashboard_id
            ? item.ic_dashboard_url
            : item.ic_dashboard_view;

        item.ic_content_type = item.ic_org_integration_id ?
          integrationData?.find(data => data.ic_org_integration_id === item.ic_org_integration_id).integration_name
          : contentTypeMap[item.ic_content_type];
        item.metricsDashboardType = item.ic_mm_dashboard_id ? DashboardTypes?.find(dashboardtype => dashboardtype.ic_mm_dashboard_id === item.ic_mm_dashboard_id).ic_mm_dashboard_name : "";
        item.ic_refresh_rate = item.ic_refresh_rate === null ? "-" : item.ic_refresh_rate === 0 ? "None" : String(item.ic_refresh_rate);
        item.ic_browser_url = item.ic_browser_url ? item.ic_browser_url : "-";
      });
      setTableValues(data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      const { statusCode, message, redirect_url } = error.response.data;
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
      if (statusCode === 403) {
        window.open(redirect_url, "_self");
      }
    }
  };

  useEffect(() => {
    fetchData();
    getIntegrationData();
    setGlobalFilter(contentGlobalSearchData);
    setInitialLoad(true);
  }, []);

  useEffect(() => {
    if (!globalFilter && initialLoad) {
      dispatch(setContentGlobalSearch(""));
    }
  }, [globalFilter]);

  const handleGlobalSearch = (event) => {
    const { value } = event.target;
    dispatch(setContentGlobalSearch(value));
    setGlobalFilter(value);
  }

  const handleContentPreviewClose = () => {
    // setPreviewModal({ openPreview: false, contentType: updateContentType, chooseFit: updateContentChooseFit, previewData: "" });
  };

  // Map Content to Screens
  const mapContentInputs = { id: "", contentname: "" };
  const [mapContentModalInputs, setMapContentModalInputs] = useState(mapContentInputs);
  const [mapContentDialog, setMapContentDialog] = useState(false);
  const [selectedScreen, setSelectedScreen] = useState([]);
  const [mapContentPublishAlert, setMapContentPublishAlert] = useState(false);

  const formatDate = (input) => {
    if (input) {
      const newDate = new Date(input);
      return newDate.toLocaleString();
    }
    return "";
  }

  const handleSaveContent = async (formData, content_Type, imageVideoFilename) => {
    const shouldSetUploadFileLoader = content_Type === "Image" || content_Type === "Video";
    const { uploadFilename } = imageVideoFilename;
    setContentFilename(uploadFilename);
    setContentUploadProgressText("Uploading 0% Completed");

    if (shouldSetUploadFileLoader) {
      setUploadFileLoader(true);
    }

    try {
      const response = await axios.post(`${apiConstants.GET_API_URL}addNewContent`, formData,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "multipart/form-data",
          },
        });

      if (response.data.statusCode === 200) {
        if (shouldSetUploadFileLoader) {
          setUploadFileLoader(false);
        }
        setContentFilename("");
        setContentUploadProgressText("");
        setAddContentDialog(false);
        dispatch(resetDashboardState());
        setTimeout(() => { dispatch(showAlertPopup({ isOpen: true, severity: "success", message: "Content Added Successfully" })); }, 250);
      }
      dispatch(resetContentUploadProgress());
      fetchData();
    } catch (error) {
      setUploadFileLoader(false);
      const { statusCode, message, redirect_url } = error.response.data;
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
      if (statusCode === 403) {
        window.open(redirect_url, "_self");
      }
    }
  };

  const handleModifyContent = async (formData) => {
    const shouldSetUploadFileLoader = rowData.content_Type === "Image" || rowData.content_Type === "Video";
    try {
      const response = await axios.post(`${apiConstants.GET_API_URL}updateContent`, formData,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const { statusCode, transfer_status } = response.data;

      if (statusCode === 200) {
        if (shouldSetUploadFileLoader) {
          setUploadFileLoader(false);
        }
        setContentWarning({ type: null, contentIds: null, contentStatus: null, contentData: null, modifiedStatus: null });
        setIsContentStatusChanged(false);
        setEditContentModal(false);
        const isContentPlaylistWithChanges = rowData.content_Type === "Content Playlist" && transfer_status === "playlist_changes" && rowData.mapped_screens.length > 0;
        const hasMappedScreens = rowData.mapped_screens.length > 0 && rowData.content_Type !== "Content Playlist";

        if (isContentPlaylistWithChanges || hasMappedScreens) {
          setOpenProgress(true);
        } else {
          setTimeout(() => { dispatch(showAlertPopup({ isOpen: true, severity: "success", message: "Content Updated Successfully" })); }, 250);
        }
        dispatch(resetDashboardState());
      }
      fetchData();
    } catch (error) {
      setUploadFileLoader(false);
      const { statusCode, message, redirect_url } = error.response.data;
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
      if (statusCode === 403) {
        window.open(redirect_url, "_self");
      }
    }
  }

  const uploadProgressText = useMemo(() => {
    if (uploadFilename === contentFilename) {
      setContentUploadProgressText(`Uploading ${uploadPercent}% Completed`);
      return `Uploading ${uploadPercent}% Completed`;
    }
    return contentUploadProgressText;
  }, [uploadPercent, uploadFilename]);

  const handleUpdateContent = async (formData, inputData) => {
    const { content_Ids, content_Type, isContentStatusChanged, row_Data, mapped_Screens, uploadFilename } = inputData;
    setIsContentStatusChanged(isContentStatusChanged);
    setSelectedScreen(mapped_Screens);
    setContentFilename(uploadFilename);
    setContentUploadProgressText("Uploading 0% Completed");

    setContentType(content_Type);
    setMapContentModalInputs({ id: row_Data.content_id, contentname: "" });
    const shouldSetUploadFileLoader = content_Type === "Image" || content_Type === "Video";

    if (isContentStatusChanged) {
      const selectedContent = [{ ic_content_id: row_Data.content_id }];
      const { content_Status } = row_Data;
      const isContentExistsInScreenOrPlaylist = await checkContentInScreenOrPlaylist(selectedContent);

      if (isContentExistsInScreenOrPlaylist) {
        setContentWarning({
          type: content_Status === "Disabled" ? "ContentInScreenOrPlaylist_DisableState" : "ContentInScreenOrPlaylist_EnableState",
          contentIds: content_Ids, contentStatus: "updateContent", contentData: formData, modifiedStatus: content_Status === "Disabled" ? "Enabled" : "Disabled",
        });
        return;
      } else {
        setContentWarning({ type: null, contentIds: null, contentStatus: null, contentData: null, modifiedStatus: null });
      }
    }

    if (shouldSetUploadFileLoader) {
      setUploadFileLoader(true);
    }

    try {
      const response = await axios.post(`${apiConstants.GET_API_URL}updateContent`, formData,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const { statusCode, transfer_status } = response.data;

      if (statusCode === 200) {
        if (shouldSetUploadFileLoader) {
          setUploadFileLoader(false);
        }

        setContentFilename("");
        setContentUploadProgressText("");
        setEditContentModal(false);
        const isContentPlaylistWithChanges = content_Type === "Content Playlist" && transfer_status === "playlist_changes" && row_Data.mapped_screens.length > 0;
        const hasMappedScreens = row_Data.mapped_screens.length > 0 && content_Type !== "Content Playlist";

        if (isContentPlaylistWithChanges || hasMappedScreens) {
          setOpenProgress(true);
        } else {
          setTimeout(() => { dispatch(showAlertPopup({ isOpen: true, severity: "success", message: "Content Updated Successfully" })); }, 250);
        }
      }
      dispatch(resetContentUploadProgress());
      fetchData();
    } catch (error) {
      setUploadFileLoader(false);
      const { statusCode, message, redirect_url } = error.response.data;
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
      if (statusCode === 403) {
        window.open(redirect_url, "_self");
      }
    }
  };

  const handleRowEdit = async (row) => {
    const { ic_content_type, ic_content_id, mapped_screens, ic_content_status } = row.original;
    if (ic_content_type === "Machine Metrics") {
      const { ic_activeflag } = (await getIntegrationData())?.[0] || {};
      if (ic_activeflag !== 1) {
        showAlert("error", "Please enable the integration flag");
        return;
      }
    }
    setRowData({ content_id: ic_content_id, mapped_screens: mapped_screens, content_Status: ic_content_status, content_Type: ic_content_type });
    dispatch(setEditContentRowData(row.original));
    if (mapped_screens.trim().length > 0) {
      dispatch(getScreenData({ headers, content_id: ic_content_id }));
    }
    setSelectedScreen([]);
    setEditContentModal(true);
  };

  const handleContentMapping = () => {
    const content_id = Object.keys(rowSelection).map(String);

    if (content_id.length === 0) {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "Please select at least one content in the list" }));
      return;
    }
    if (content_id.length > 1) {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "You can only select one content for mapping" }));
      return;
    }

    const selectedContentId = parseInt(content_id[0]);
    const selectedContent = tableValues.find((data) => data.ic_content_id === selectedContentId);

    if (selectedContent.ic_content_status === "Disabled") {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "Mapping is allowed only for enabled contents" }));
      return;
    }

    if (selectedContent.ic_content_type === "Machine Metrics" && integrationActiveFlag !== 1) {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "Please enable the integration flag" }));
      return;
    }

    dispatch(getSelectedContent({ rowSelection, tableValues }));
    setSelectedScreen([]);
    setMapContentDialog(true);
  };

  const handleCloseProgress = () => {
    setOpenProgress(false);
    setContentType("");
    setMapContentModalInputs(mapContentInputs);
  }

  const handlePublishContent = async () => {
    const screen_uiids = selectedScreen.map(data => data.id);
    const payload = { screen_uiids: screen_uiids, content_id: mapContentModalInputs.id.toString(), mapping_notes: "" };

    try {
      setIsPublishing(true);
      const response = await axios.post(`${apiConstants.GET_API_URL}createMapping`, payload, { headers });

      if (response.data.statusCode === 200) {
        setMapContentDialog(false);
        setOpenProgress(true);
        setMapContentPublishAlert(false);
        setRowSelection({});
      }
      fetchData();
    } catch (error) {
      const { statusCode, message, redirect_url } = error.response.data;
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
      if (statusCode === 403) {
        window.open(redirect_url, "_self");
      }
    } finally {
      setIsPublishing(false);
    }
  };

  const getMenuData = async (selectedModule, workbookObject) => {
    setOpenDrawer(false);

    if (typeof workbookObject === "object" &&
      workbookObject !== null &&
      !("nativeEvent" in workbookObject) && // Exclude event objects
      Object.keys(workbookObject).length > 0) {
      dispatch(getMenuDataList({ selectedModule, workbookObject }));
    }
  };

  const validateContentDeletion = (data) => {
    let hasEnabled = false;
    let hasDisabled = false;

    data.forEach(item => {
      if (item.ic_content_status === "Enabled") {
        hasEnabled = true;
      }
      if (item.ic_content_status === "Disabled") {
        hasDisabled = true;
      }
    });

    if (hasEnabled && hasDisabled) {
      return `The current selection contains mix of Enabled and Disabled contents. The Delete process is only applicable to contents with Disabled status. Please change your selection to include content with just "Disabled" statuses and try the Delete Content operation again.`;
    } else if (hasEnabled) {
      return "The Delete process is only applicable to contents with Disabled status.";
    } else if (hasDisabled) {
      return "Yes";
    }
  };

  const validateActivateDeactivate = (data) => {
    const enable = data.every(item => item.ic_content_status === "Disabled");
    const disable = data.every(item => item.ic_content_status === "Enabled");

    return [enable, disable];
  }

  const isCustomViewDeleted = (data) => {
    return data.some(item => item.ic_view_type !== "Original" && item.ic_custom_view_delete_flag === 1);
  }

  const handleDeleteContentsAPI = async (rowId) => {
    try {
      const response = await axios.post(`${apiConstants.GET_API_URL}deleteContents`, { content_ids: rowId }, { headers });

      if (response.data.statusCode === 200) {
        dispatch(showAlertPopup({ isOpen: true, severity: "success", message: "Selected Contents Deleted Successfully" }));
        setRowSelection({});
        setContentWarning({ type: null, contentIds: null, contentStatus: null, contentData: null, modifiedStatus: null })
      }
      fetchData();
    } catch (error) {
      const { statusCode, message, redirect_url } = error.response.data;
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
      if (statusCode === 403) {
        window.open(redirect_url, "_self");
      }
    }
  }

  const handleDeleteContents = async () => {
    const rowId = Object.keys(rowSelection).map(Number);

    if (rowId.length === 0) {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "Please select at least one content in the list" }));
      return;
    }
    const selectedRows = tableValues.filter((data) => rowId.includes(data.ic_content_id));
    const deletionMessage = validateContentDeletion(selectedRows);

    if (deletionMessage !== "Yes") {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: deletionMessage }));
      return;
    }

    if (await checkContentInScreenOrPlaylist(selectedRows)) {
      setContentWarning({ type: "ContentInScreenOrPlaylist_MultiDelete", contentIds: rowId, contentStatus: "delete", contentData: null, modifiedStatus: null });
      return;
    } else {
      setContentWarning({ type: "ContentNotInScreenOrPlaylist_MultiDelete", contentIds: rowId, contentStatus: "delete", contentData: null, modifiedStatus: null });
      return;
    }
  };

  const handleEnableDisableContentAPI = async (rowId, enable = false) => {
    try {
      const idParams = rowId.map(String);
      const response = await axios.post(`${apiConstants.GET_API_URL}changeContentStatus`, { content_ids: idParams }, { headers });

      if (response.data.statusCode === 200) {
        dispatch(showAlertPopup({
          isOpen: true, severity: "success",
          message: enable ? "Selected Contents Enabled Successfully" : "Selected Contents Disabled Successfully"
        }));
        setRowSelection({});
        setContentWarning({ type: null, contentIds: null, contentStatus: null, contentData: null, modifiedStatus: null });
      }
      fetchData();
    } catch (error) {
      const { statusCode, message, redirect_url } = error.response.data;
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
      if (statusCode === 403) {
        window.open(redirect_url, "_self");
      }
    }
  }

  const checkContentInScreenOrPlaylist = async (selectedRows) => {
    const contentIDs = selectedRows.map(item => item.ic_content_id);
    const playlistContents = tableValues.filter(content => content.ic_content_type === "Content Playlist");

    try {
      const response = await axios.post(`${apiConstants.GET_API_URL}getScreens`, { org_id: "test" }, { headers });
      const { data } = response.data;

      const isExistsInPlaylist = playlistContents.some(item => item.playlist_contents && item.playlist_contents.some(parent => contentIDs.includes(parent.content_id)));
      const isExistsInScreen = data.some(screens => contentIDs.includes(screens.ic_content_id));

      return isExistsInPlaylist || isExistsInScreen;

    } catch (error) {
      const { statusCode, message, redirect_url } = error.response.data;
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
      if (statusCode === 403) {
        window.open(redirect_url, "_self");
      }
      return false;
    }
  }

  const validateEnableDisableContent = async () => {
    const rowId = Object.keys(rowSelection).map(Number);
    if (rowId.length === 0) {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "Please select at least one content in the list" }));
      return;
    }

    const selectedRows = tableValues.filter((data) => rowId.includes(data.ic_content_id));
    const [enable, disable] = validateActivateDeactivate(selectedRows);
    const isCustomViewRemoved = isCustomViewDeleted(selectedRows);

    if (isCustomViewRemoved) {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "The custom view of the workbook is no longer available in IntelliDash Web Portal" }));
      return;
    }

    if (!enable && !disable) {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "The Enable/Disable process is only applicable to contents with either an Enabled or Disabled status" }));
      return;
    }

    if (await checkContentInScreenOrPlaylist(selectedRows)) {
      setContentWarning({
        type: enable ? "ContentInScreenOrPlaylist_DisableState" : "ContentInScreenOrPlaylist_EnableState", contentIds: rowId,
        contentStatus: enable, contentData: null, modifiedStatus: null
      });
      return;
    } else {
      setContentWarning({
        type: enable ? "ContentNotInScreenOrPlaylist_DisableState" : "ContentNotInScreenOrPlaylist_EnableState", contentIds: rowId,
        contentStatus: enable, contentData: null, modifiedStatus: null
      });
      return;
    }
  }

  const handleDeleteContentRecords = async (row) => {
    const { ic_content_status, ic_content_id } = row.original;
    setRowData(row.original);

    if (ic_content_status !== "Disabled") {
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "The Delete process is only applicable to contents with Disabled status" }));
      return;
    }

    if (await checkContentInScreenOrPlaylist([row.original])) {
      setContentWarning({ type: "ContentInScreenOrPlaylist_SingleDelete", contentIds: [ic_content_id], contentStatus: "delete", contentData: null, modifiedStatus: null });
      return;
    } else {
      setContentWarning({ type: "ContentNotInScreenOrPlaylist_SingleDelete", contentIds: [ic_content_id], contentStatus: "delete", contentData: null, modifiedStatus: null });
      return;
    }
  };

  const handleCloseDialog = (_, reason) => {
    if (reason !== "backdropClick") {
      setAddContentDialog(false);
      setEditContentModal(false);
      setMapContentDialog(false);
      setContentType("");
      setMapContentModalInputs(mapContentInputs);
      setRowSelection({});
      setOpenDrawer(false);
      setIsContentStatusChanged(false);
    }
  };

  const handleConfirmDelete = async () => {
    const { ic_content_id } = rowData;
    try {
      const response = await axios.post(`${apiConstants.GET_API_URL}deleteContent`, { content_id: ic_content_id }, { headers });

      if (response.data.statusCode === 200) {
        setContentWarning({ type: null, contentIds: null, contentStatus: null, contentData: null, modifiedStatus: null });
        dispatch(showAlertPopup({ isOpen: true, severity: "success", message: "Content Deleted Successfully" }));
        setRowData({});
      }
      fetchData();
    } catch (error) {
      const { statusCode, message, redirect_url } = error.response.data;
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
      if (statusCode === 403) {
        window.open(redirect_url, "_self");
      }
    }
  };

  const handleResetProcess = () => {
    !isContentStatusChanged && setRowData({});
    setRowSelection({});
    setContentWarning({ type: null, contentIds: null, contentStatus: null, contentData: null, modifiedStatus: null });
  };

  const columns = useMemo(
    () => [
      {
        header: "Content Name",
        accessorKey: "ic_content_name",
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Content Type",
        accessorKey: "ic_content_type",
        size: 155,
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Status",
        accessorKey: "ic_content_status",
        size: 100,
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ({ renderedCellValue }) => (
          <Stack direction="row" spacing={1}>
            <Chip
              label={renderedCellValue}
              size="small"
              sx={{
                backgroundColor: renderedCellValue === "Enabled" ? "green" : renderedCellValue === "Disabled" ? "red" : "#ffcb7f",
                width: "100px", color: "#fff",
              }}
            />
          </Stack>
        ),
      },
      {
        header: "List of Screens",
        accessorKey: "mapped_screens",
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue;
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span
                style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", }}
              >
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Image Fit Type",
        accessorKey: "ic_fit_type",
        size: 100,
      },
      {
        header: "Dashboard Type",
        accessorKey: "metricsDashboardType",
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Dashboard Path",
        accessorKey: "ic_dashboard_view",
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span
                style={{
                  textAlign: "left",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "URL",
        accessorKey: "ic_browser_url",
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Refresh Rate",
        accessorKey: "ic_refresh_rate",
        Cell: ({ renderedCellValue }) => {
          return <span> {renderedCellValue ? renderedCellValue : "-"} </span>
        },
      },
      {
        header: "Created by",
        accessorKey: "ic_createdby",
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Created on",
        accessorKey: "ic_createdon",
        sortingFn: (rowA, rowB, columnId) => {
          const dateA = new Date(rowA.getValue(columnId));
          const dateB = new Date(rowB.getValue(columnId));
          return dateA - dateB;
        },
        sortDescFirst: false, // FORCE first click = ASC
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Last Updated by",
        accessorKey: "ic_updatedby",
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
      {
        header: "Last Updated on",
        accessorKey: "ic_updatedon",
        sortingFn: (rowA, rowB, columnId) => {
          const dateA = new Date(rowA.getValue(columnId));
          const dateB = new Date(rowB.getValue(columnId));
          return dateA - dateB;
        },
        sortDescFirst: false, // FORCE first click = ASC
        Cell: ({ renderedCellValue }) => {
          const cellValue = renderedCellValue || "-";
          const displayValue = (
            <Tooltip title={cellValue} arrow>
              <span style={{ textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                {cellValue}
              </span>
            </Tooltip>
          );

          return (<span>{cellValue.length > 15 ? displayValue : cellValue}</span>);
        },
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data: tableValues,
    getRowId: (row) => row.ic_content_id,
    onRowSelectionChange: setRowSelection,
    onGlobalFilterChange: setGlobalFilter,
    muiSearchTextFieldProps: {
      sx: { minWidth: '300px' }, variant: 'outlined', value: contentGlobalSearchData, onChange: handleGlobalSearch
    },
    state: { rowSelection, isLoading: isLoading, globalFilter },
    filterFns: {
      myCustomFilterFn: (row, id, filterValue) =>
        row.getValue(id)?.toString().toLowerCase().trim().includes(filterValue?.toString().toLowerCase().trim())
    },
    globalFilterFn: 'myCustomFilterFn',
    displayColumnDefOptions: {
      "mrt-row-expand": {
        Header: () => (
          <Stack direction="row" alignItems="center">
            <MRT_ExpandAllButton table={table} />
            <Box>Groups</Box>
          </Stack>
        ),
        GroupedCell: ({ row, table }) => {
          const { grouping } = table.getState();
          return row.getValue(grouping[grouping.length - 1]);
        },
        enableResizing: true,
        muiTableBodyCellProps: ({ row }) => ({
          sx: (theme) => ({
            color:
              row.depth === 0
                ? theme.palette.primary.main
                : row.depth === 1
                  ? theme.palette.secondary.main
                  : undefined,
          }),
        }),
        size: 200,
      },
      "mrt-row-select": {
        visibleInShowHideMenu: false,
        size: 20,
      },
      "mrt-row-actions": {
        visibleInShowHideMenu: false,
      },
    },
    renderTopToolbarCustomActions: () => (
      <Stack spacing={1} direction="row" className="tab-responsive">
        <Fab className="fab-btn-responsive" variant="extended" size="small" onClick={() => checkMaxContentsLimit()}
          sx={{
            backgroundColor: "#003366", color: "#fff", textTransform: "none", transition: "0.3s ease-in-out",
            "&:hover": { backgroundColor: "#0d45a5", color: "#fff" }
          }} disabled={isInternalUserMapped === 1}
        >
          <AddIcon className="fab-btn-icon-responsive" sx={{ fontSize: "20px", mr: 0.5 }} />
          Add Content
        </Fab>
        <Fab className="fab-btn-responsive" variant="extended" size="small" onClick={handleContentMapping} disabled={!Object.keys(rowSelection).length || isInternalUserMapped === 1}
          sx={{
            backgroundColor: "#003366", color: "#fff", textTransform: "none", transition: "0.3s ease-in-out",
            "&:hover": {
              backgroundColor: Object.keys(rowSelection).length ? "#0d45a5" : "rgba(0, 0, 0, 0.12)",
              color: Object.keys(rowSelection).length ? "#fff" : "rgba(0, 0, 0, 0.26)",
            }
          }}
        >
          Map Content To Screens
        </Fab>
        <Fab className="fab-btn-responsive" variant="extended" size="small" onClick={validateEnableDisableContent} disabled={!Object.keys(rowSelection).length || isInternalUserMapped === 1}
          sx={{
            backgroundColor: "#003366", color: "#fff", textTransform: "none", transition: "0.3s ease-in-out",
            "&:hover": {
              backgroundColor: Object.keys(rowSelection).length ? "#0d45a5" : "rgba(0, 0, 0, 0.12)",
              color: Object.keys(rowSelection).length ? "#fff" : "rgba(0, 0, 0, 0.26)",
            }
          }}
        >
          Enable / Disable Content
        </Fab>
        <Fab className="fab-btn-responsive" variant="extended" size="small" onClick={handleDeleteContents} disabled={!Object.keys(rowSelection).length || isInternalUserMapped === 1}
          sx={{
            backgroundColor: "#003366", color: "#fff", textTransform: "none", transition: "0.3s ease-in-out",
            "&:hover": {
              backgroundColor: Object.keys(rowSelection).length ? "#0d45a5" : "rgba(0, 0, 0, 0.12)",
              color: Object.keys(rowSelection).length ? "#fff" : "rgba(0, 0, 0, 0.26)",
            }
          }}
        >
          Delete Content
        </Fab>
      </Stack>
    ),
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex" }}>
        <Tooltip title="Delete">
          <IconButton color="error" style={{ display: isInternalUserMapped === 1 ? "none" : "inline-flex" }} onClick={() => handleDeleteContentRecords(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Edit">
          <IconButton color="inherit" onClick={() => handleRowEdit(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    positionToolbarDropZone: "bottom",
    enableEditing: true,
    enableRowActions: true,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnActions: false,
    enableRowSelection: true,
    enableStickyHeader: true,
    enableGrouping: false,
    enableFacetedValues: true,
    enableColumnResizing: true,
    enableColumnOrdering: false,
    enableColumnFilterModes: true,
    groupedColumnMode: "remove",
    positionToolbarAlertBanner: "bottom",
    enableExpandAll: true,
    muiTableContainerProps: { sx: { maxHeight: `${screenHeight}px` } },
    muiTablePaperProps: { sx: { width: "100%" } },
    initialState: {
      density: "compact",
      expanded: false,
      pagination: { pageIndex: 0, pageSize: 50 },
      sorting: [{ id: "ic_content_name", desc: false }],
      columnPinning: { left: ["mrt-row-select", "mrt-row-actions"] },
      showGlobalFilter: contentGlobalSearchData ? true : false,
    },
    muiCircularProgressProps: {
      sx: { color: "#003366" }, thickness: 5, size: 55
    },
    muiSkeletonProps: {
      animation: "pulse", height: 28
    },
    localization: {
      dropToGroupBy: "Drag a column here to group by it",
      thenBy: " ",
    },
    muiPaginationProps: {
      rowsPerPageOptions: [10, 50, 100],
    },
    muiTableHeadCellProps: {
      sx: {
        '& .Mui-TableHeadCell-Content-Wrapper': {
          whiteSpace: "wrap"
        },
      }
    },
    muiSelectCheckboxProps: ({ row }) => ({
      inputProps: {
        id: `checkbox-${row.original.ic_content_id}`,
      },
    }),
    muiSelectAllCheckboxProps: () => ({
      inputProps: {
        id: `checkbox-content-head`,
      },
    }),
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight * 0.5);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleContentAPICall = () => {
    const { type, contentIds, contentStatus, contentData } = contentWarning;
    if (type === "ContentInScreenOrPlaylist_MultiDelete" || type === "ContentNotInScreenOrPlaylist_MultiDelete") {
      handleDeleteContentsAPI(contentIds);
    } else if (type === "ContentInScreenOrPlaylist_SingleDelete" || type === "ContentNotInScreenOrPlaylist_SingleDelete") {
      handleConfirmDelete();
    } else if (isContentStatusChanged && contentStatus === "updateContent") {
      handleModifyContent(contentData);
    } else {
      handleEnableDisableContentAPI(contentIds, contentStatus);
    }
  }

  const showAlert = (alertType, errorMessage) => {
    dispatch(showAlertPopup({ isOpen: true, severity: alertType, message: errorMessage }));
  }

  const handleConfirmation = (contentModalInputs, contentType, selectedScreen) => {
    setMapContentModalInputs(contentModalInputs);
    setContentType(contentType);
    setSelectedScreen(selectedScreen);
    setMapContentPublishAlert(true)
  }

  const handleCloseAddContentModal = (_, reason) => {
    if (reason !== "backdropClick") {
      setAddContentDialog(false);
      setOpenDrawer(false);
    }
  }

  const handleCloseEditContentModal = (_, reason) => {
    if (reason !== "backdropClick") {
      setEditContentModal(false);
      setOpenDrawer(false);
    }
  }

  const handleCloseMapContentModal = (_, reason) => {
    if (reason !== "backdropClick") {
      setMapContentDialog(false);
    }
  }

  // ── Max-contents guard ───────────────────────────────────────────────────
  /**
   * Call this before opening the "Add Content" flow.
   * Returns true if the user can proceed, false if they've hit their limit.
   */
  const checkMaxContentsLimit = () => {

    if (tableValues.length >= maxContents) {
      showAlert(
        "error",
        "You have reached your maximum content limit. Delete existing contents to add a new one or upgrade to add more contents."
      );
      return false;
    }
    setAddContentDialog(true);
  };

  return (
    <Grid container item xs={12} padding={2} style={{ marginTop: "-10px" }}>
      {/* New content dialog */}
      <Dialog open={addContentDialog} onClose={handleCloseAddContentModal} fullWidth maxWidth="md" disableEscapeKeyDown style={{ zIndex: 5 }} TransitionComponent={Transition}>
        <DialogTitle sx={{ m: 0, p: 1, pl: 2, pr: 2, color: "white", backgroundColor: "#003366" }}>
          Add Content
          <IconButton aria-label="close" onClick={handleCloseAddContentModal} style={{ float: "right", color: "gray" }}><CloseIcon /></IconButton>
        </DialogTitle>
        <CreateContentDialog openDashboardMenu={() => setOpenDrawer(true)} showAlert={showAlert} createContent={handleSaveContent} closeAddContentModal={handleCloseAddContentModal} currentContentCount={tableValues.length} currentStorageUsedGB={0} />
      </Dialog>

      {/* Edit content dialog */}
      <Dialog open={editContentModal} onClose={handleCloseEditContentModal} fullWidth maxWidth="md" disableEscapeKeyDown style={{ zIndex: 5 }} TransitionComponent={Transition}>
        <DialogTitle sx={{ m: 0, p: 1, pl: 2, pr: 2, color: "white", backgroundColor: "#003366" }}>
          Edit Content
          <IconButton aria-label="close" onClick={handleCloseEditContentModal} style={{ float: "right", color: "gray" }}><CloseIcon /></IconButton>
        </DialogTitle>
        <EditContentDialog showAlert={showAlert} openDashboardMenu={() => setOpenDrawer(true)} updateContent={handleUpdateContent} closeEditContentModal={handleCloseEditContentModal} currentContentCount={tableValues.length} currentStorageUsedGB={0} />
      </Dialog>

      {/* Map Content to Screens Dialog */}
      <Dialog open={mapContentDialog} onClose={handleCloseMapContentModal} fullWidth maxWidth="sm" disableEscapeKeyDown TransitionComponent={Transition}>
        <DialogTitle sx={{ m: 0, p: 1, pl: 2, pr: 2, color: "white", backgroundColor: "#003366" }}>
          Map Content to Screens
          <IconButton aria-label="close" onClick={handleCloseMapContentModal} style={{ float: "right", color: "gray" }}><CloseIcon /></IconButton>
        </DialogTitle>
        <MapContentDialog showAlert={showAlert} openConfirmation={handleConfirmation} closeMapContentModal={handleCloseMapContentModal} />
      </Dialog>

      {/* Map Content to Screens Confirmation */}
      <Dialog open={mapContentPublishAlert} onClose={handleCloseDialog} fullWidth maxWidth="sm" disableEscapeKeyDown TransitionComponent={Transition}>
        <DialogTitle style={{ color: "#003366", fontWeight: "bold" }}>Confirmation</DialogTitle>
        <DialogContent>
          <div>
            Are you sure you want to update the content on the screens?<br />
            By clicking "<em>Yes</em>" you are authorizing the display of the content on the selected AristoCAST application.
          </div>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" size="small" color="success" onClick={handlePublishContent} disabled={isPublishing} style={{ textTransform: "none" }} >
            Yes
          </Button>
          <Button variant="contained" size="small" color="error" onClick={() => setMapContentPublishAlert(false)} style={{ textTransform: "none" }}>
            No
          </Button>
        </DialogActions>
      </Dialog>

      {/* Enable / Disable confirmation */}
      <Dialog open={contentWarningTypes.includes(contentWarning.type)} onClose={handleCloseDialog} fullWidth maxWidth="md" disableEscapeKeyDown TransitionComponent={Transition}>
        <DialogTitle style={{ color: "#003366", fontWeight: "bold" }}>Alert</DialogTitle>
        <DialogContent>
          {contentWarning.type === "ContentInScreenOrPlaylist_EnableState" &&
            <div>
              Disabling the selected content will stop displaying the content on all the associated Screens. All Screens, either mapped with the
              selected content or mapped to Content Playlists that contain the selected content, will be affected.<br /><br />
              Click "<em>Yes I Confirm</em>" to Disable the Content or "<em>Cancel</em>" to exit without any changes.<br />
              The summary of the affected Screens and Content Playlists are provided below,
            </div>
          }
          {contentWarning.type === "ContentInScreenOrPlaylist_DisableState" &&
            <div>
              Enabling the selected content will start displaying the content on all the associated Screens. All Screens, either mapped with the
              selected content or mapped to Content Playlists that contain the selected content, will be affected.<br /><br />
              Click "<em>Yes I Confirm</em>" to Enable the Content or "<em>Cancel</em>" to exit without any changes.<br />
              The summary of the affected Screens and Content Playlists are provided below,
            </div>
          }
          {contentWarning.type === "ContentNotInScreenOrPlaylist_EnableState" &&
            <div>Click "<em>Yes I Confirm</em>" to Disable the Content or "<em>Cancel</em>" to exit without any changes.</div>
          }
          {contentWarning.type === "ContentNotInScreenOrPlaylist_DisableState" &&
            <div>Click "<em>Yes I Confirm</em>" to Enable the Content or "<em>Cancel</em>" to exit without any changes.</div>
          }
          {(contentWarning.type === "ContentInScreenOrPlaylist_SingleDelete" || contentWarning.type === "ContentInScreenOrPlaylist_MultiDelete") &&
            <div>
              Deleting the selected content will remove the content from all the associated Screens and associated Content Playlists.<br /><br />
              Click "<em>Yes I Confirm</em>" to Delete the Content or "<em>Cancel</em>" to exit without any changes.<br />
              The summary of the affected Screens and Content Playlists are provided below,
            </div>
          }
          {(contentWarning.type === "ContentNotInScreenOrPlaylist_SingleDelete" || contentWarning.type === "ContentNotInScreenOrPlaylist_MultiDelete") &&
            <div>Click "<em>Yes I Confirm</em>" to Delete the Content or "<em>Cancel</em>" to exit without any changes.</div>
          }
          {contentTypesToShow.includes(contentWarning.type) && <div><MappedContentList selectedContents={contentWarning} /></div>}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" size="small" color="success" onClick={handleContentAPICall} style={{ textTransform: "none" }}>Yes I Confirm</Button>
          <Button variant="contained" size="small" color="error" onClick={handleResetProcess} style={{ textTransform: "none" }}>Cancel</Button>
        </DialogActions>
      </Dialog>
      <MaterialReactTable table={table} />
      <MegaMenu openDrawer={openDrawer} onClose={getMenuData} />
      <PreviewContent previewContent={previewModal} onClose={handleContentPreviewClose} />
      {openProgress ?
        <ContentProgress openProgress={openProgress} onClose={handleCloseProgress} contentId={mapContentModalInputs.id.toString()}
          contentType={contentType} screenData={selectedScreen} /> : ""}
      {uploadFileLoader && <Backdrop open={uploadFileLoader} sx={{ zIndex: 15 }}>
        {/* <span style={{ color: "#fff" }}>{`Uploading ${uploadFilename === contentFilename && uploadPercent}% Completed`}</span> */}
        <span style={{ color: "#fff" }}>{uploadProgressText}</span>
        <div style={{ marginTop: "8px", marginLeft: "2px" }}>
          <ThreeDots visible={uploadFileLoader} height="25" width="25" color="#fff" radius="9" ariaLabel="three-dots-loading" />
        </div>
      </Backdrop>}
    </Grid>
  );
};

export default ContentTable;
